module.exports = __webpack_public_path__ + "img/j2.0c9767c4.jpg";